export const CGU_LINK = 'https://welcomehomemalou.notion.site/Consulter-les-CGU-dd62041f02ab459cb101d60c8546a62e';
export const MALOU_PRIVACY_POLICY_FR = 'https://welcomehomemalou.notion.site/FR-4b1d0788b1c848c78ca5bfa20eadbf48';
export const MALOU_PRIVACY_POLICY_EN = 'https://welcomehomemalou.notion.site/EN-a466f0380f604a78a0c46ba20e561612';

export enum FilterType {
    REVIEWS = 'reviews',
    COMMENTS = 'comments',
    INSIGHTS = 'insights',
    PLATFORMS_INSIGHTS = 'platforms_insights',
    POSTS = 'posts',
    MEDIA = 'media',
    MENTIONS = 'mentions',
}

export const postsUpdateTexts = Object.freeze({
    GMB: ['Les horaires ont été mises à jour.', 'Hours were updated.'],
});

export const facebookNewPhotoLegend = [
    /a une nouvelle photo/,
    /ha añadido una foto nueva/,
    /added a new photo/,
    /さんが写真を追加しました/,
];

export enum RedirectStar {
    FOUR_STARS = 'four_stars',
    FIVE_STARS = 'five_stars',
}

export enum DescriptionSize {
    LONG = 'long',
    SHORT = 'short',
}

export const descriptionSize = Object.freeze({
    LONG: {
        key: DescriptionSize.LONG,
        maxlength: 750,
    },
    SHORT: {
        key: DescriptionSize.SHORT,
        maxlength: 100,
    },
});

export const months = Object.freeze({
    fr: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
    en: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
});

export const scopes = Object.freeze({
    FACEBOOK: [
        'pages_read_engagement',
        'pages_show_list',
        'pages_read_user_content',
        'pages_manage_metadata',
        'pages_manage_engagement',
        'read_insights',
        'pages_manage_posts',
        'pages_messaging',
        'business_management',
    ],
    INSTAGRAM: [
        'instagram_basic',
        'pages_show_list',
        'instagram_manage_comments',
        'pages_manage_metadata',
        'pages_read_engagement',
        'instagram_manage_insights',
        'instagram_content_publish',
        'instagram_manage_messages',
        'pages_messaging',
        'business_management',
    ],
    FACEBOOK_PAGE_SCOPE: [
        'pages_read_engagement',
        'pages_show_list',
        'pages_read_user_content',
        'pages_manage_metadata',
        'pages_manage_engagement',
        'pages_manage_posts',
        'pages_messaging',
    ],
    INSTAGRAM_PAGE_SCOPE: [
        'instagram_basic',
        'pages_show_list',
        'instagram_manage_comments',
        'pages_manage_metadata',
        'pages_read_engagement',
        'instagram_manage_insights',
        'instagram_content_publish',
        'instagram_manage_messages',
        'pages_messaging',
    ],
    UBEREATS: ['eats.report', 'eats.store', 'eats.store.status.write'],
    GMB: [
        'https://www.googleapis.com/auth/business.manage',
        'https://www.googleapis.com/auth/userinfo.email',
        'https://www.googleapis.com/auth/businesscommunications', // TODO: check if needed
    ],
    TIKTOK_OAUTH_SCOPE: ['user.info.basic', 'user.info.profile', 'user.info.stats', 'video.publish', 'video.upload', 'video.list'],
});

export enum PermissionStatus {
    NOT_CONNECTED = 'not_connected',
    NO_ACCESS = 'no_access',
    AVAILABLE = 'available',
}

export const defaultLabels = Object.freeze([
    'moderation.answer_comment_modal.good_luck',
    'moderation.answer_comment_modal.come_back_soon',
    'moderation.answer_comment_modal.thank_you',
    'moderation.answer_comment_modal.thanks',
    'moderation.answer_comment_modal.your_welcome',
]);

export const eventsPermissions = Object.freeze([
    {
        key: 'canCreatePostInstagram',
        permission: {
            type: 'USER',
            platformKey: 'instagram',
            list: [
                ['instagram_basic', 'instagram_content_publish', 'public_profile', 'pages_read_engagement'],
                ['instagram_basic', 'instagram_content_publish', 'public_profile', 'pages_show_list'],
            ],
        },
    },
    {
        key: 'canCreatePostFacebook',
        permission: {
            type: 'PAGE',
            platformKey: 'facebook',
            list: [['pages_read_engagement', 'pages_manage_posts', 'pages_show_list', 'public_profile']],
        },
    },
    {
        key: 'canAnswerCommentInstagram',
        permission: {
            type: 'USER',
            platformKey: 'instagram',
            list: [['instagram_basic', 'instagram_manage_comments', 'pages_show_list', 'pages_read_engagement', 'public_profile']],
        },
    },
    {
        key: 'canAnswerCommentFacebook',
        permission: {
            type: 'PAGE',
            platformKey: 'facebook',
            list: [['pages_show_list', 'pages_read_user_content', 'pages_manage_engagement', 'public_profile']],
        },
    },
    {
        key: 'canAnswerReviewFacebook',
        permission: {
            type: 'PAGE',
            platformKey: 'facebook',
            list: [['pages_show_list', 'pages_read_user_content', 'pages_manage_engagement', 'public_profile']],
        },
    },
    {
        key: 'canSearchInspirationsInstagram',
        permission: {
            type: 'USER',
            platformKey: 'instagram',
            list: [
                ['instagram_basic', 'pages_read_engagement', 'public_profile', 'instagram_manage_insights'],
                ['instagram_basic', 'pages_show_list', 'public_profile', 'instagram_manage_insights'],
            ],
        },
    },
]);

export enum IgStoryType {
    REPLY_TO = 'reply_to',
    MENTION = 'mention',
}

export const igMessageReaction = 'love';

export enum FacebookMessageType {
    MESSAGE_TAG = 'MESSAGE_TAG',
    UPDATE = 'UPDATE',
    RESPONSE = 'RESPONSE',
}

export enum FacebookThumbUp {
    ReplaceText = '__THUMB_UP__',
    FbSocialId = '369239263222822',
}

export enum TemplateType {
    REVIEW = 'review',
    COMMENT = 'comment',
    MESSAGE = 'message',
}

export enum TemplateStatus {
    ACTIVE = 'active',
    PENDING = 'pending',
}

export enum ApiKeyRole {
    BUSINESS_PARTNER = 'business_partner',
    CLIENT = 'client',
    INTERNAL_APP = 'internal_app',
    ORGANIZATION = 'organization',
}

export enum SimilarRestaurantCategory {
    ITALIAN_RESTAURANT = 'italian_restaurant',
    BRUNCH_BREAKFAST = 'brunch_breakfast',
    ASIAN_RESTAURANT = 'asian_restaurant',
    PIZZA_RESTAURANT = 'pizza_restaurant',
    BISTRO_PUB = 'bistro_pub',
    JAPANESE_RESTAURANT = 'japanese_restaurant',
    OCCIDENTAL_RESTAURANT = 'occidental_restaurant',
    BISTRONOMIC_RESTAURANT = 'bistronomic_restaurant',
    VEGETARIAN_VEGAN_RESTAURANT = 'vegetarian_vegan_restaurant',
    BAR_ENTERTAINMENT_VENUE = 'bar_entertainment_venue',
    COFFEE_TEA_ROOM = 'coffee_tea_room',
    GASTRONOMIC_RESTAURANT = 'gastronomic_restaurant',
    ORIENTAL_MEDITERRANEAN_RESTAURANT = 'oriental_mediterranean_restaurant',
    FISH_SEAFOOD_RESTAURANT = 'fish_seafood_restaurant',
    FAST_FOOD = 'fast_food',
    HEALTHY_FAST_FOOD = 'healthy_fast_food',
    CREPERIE = 'creperie',
    BAKERY = 'bakery',
    CATERER = 'caterer',
    GROCERY_MARKET = 'grocery_market',
    LATINO_AFRICAN_CARIBBEAN_RESTAURANT = 'latino_african_caribbean_restaurant',
    ACCOMMODATION_WELLNESS_VENUE = 'accommodation_wellness_venue',
    OTHER = 'other',
}

export enum SeoPostTopic {
    STANDARD = 'STANDARD',
    UNSPECIFIED = 'LOCAL_POST_TOPIC_TYPE_UNSPECIFIED',
    EVENT = 'EVENT',
    OFFER = 'OFFER',
    ALERT = 'ALERT',
}

export const hashtagCategoriesColor = [
    'rgb(219, 237, 219)',
    'rgb(227, 226, 224)',
    'rgb(238, 224, 218)',
    'rgb(250, 222, 201)',
    'rgb(253, 236, 200)',
    'rgb(211, 229, 239)',
    'rgb(232, 222, 238)',
    'rgb(245, 224, 233)',
    'rgb(255, 226, 221)',
];

export const hashtagGeneralColor = 'rgba(227, 226, 224, 0.5)';

export const emailRegex =
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;

export const timeRegex = /^(0[0-9]|1[0-9]|2[0-4]):[0-5][0-9]$/;

export const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,12}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/i;
export const urlWithLocalHostRegex =
    /https?:\/\/(((www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,12})|(localhost:[0-9]{1,5}))\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/i;
export const withOrWithoutHttpPartUrlRegex =
    /(?:https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,12}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/i;

export const phoneRegex = /[+]?[(]?\s?[+]?\s?[0-9]{2,3}\s?[)]?[-\s.]?(([0-9]{3}[-\s.]?[0-9]{3,9})|(([0-9]{1,4}[-\s.]?){7}))/gi;
export const punctuationRegex = /[^a-zA-ZÀ-ú0-9]+/g;

export enum ReportType {
    DAILY_REVIEWS = 'daily_reviews',
    WEEKLY_REVIEWS = 'weekly_reviews',
    WEEKLY_PERFORMANCE = 'weekly_performance',
    MONTHLY_PERFORMANCE = 'monthly_performance',
}

export const ratingTags = {
    restaurant_well_prepared: {
        fr: 'Bien préparé',
        en: 'Well prepared',
    },
    restaurant_perfectly_cooked: {
        fr: 'Cuisson parfaite',
        en: 'Perfectly cooked',
    },
    restaurant_sustainable_packaging: {
        fr: 'Conditionnement durable',
        en: 'Sustainable packaging',
    },
    restaurant_excellent_quality: {
        fr: 'Excellente qualité',
        en: 'Excellent quality',
    },
    restaurant_healthy: {
        fr: 'Healthy',
        en: 'Healthy',
    },
    restaurant_tasty: {
        fr: 'Savoureux',
        en: 'Tasty',
    },
    restaurant_fast: {
        fr: 'Rapide',
        en: 'Fast',
    },
    restaurant_accommodating: {
        fr: 'Accomodant',
        en: 'Accomodating',
    },
    restaurant_good_packaging: {
        fr: 'Bon emballage',
        en: 'Good packaging',
    },
    restaurant_excellent_value: {
        fr: 'Excellente valeur',
        en: 'Excellent value',
    },
    restaurant_not_tasty: {
        fr: 'Pas très savoureux',
        en: 'Not tasty',
    },
    restaurant_not_worth_price: {
        fr: 'Ne vaut pas le prix',
        en: 'Not worth price',
    },
    restaurant_missed_request: {
        fr: 'Instructions non respectées',
        en: 'Instructions not followed',
    },
    restaurant_creative: {
        fr: 'Créatif',
        en: 'Creative',
    },
    restaurant_delicate: {
        fr: 'Délicat',
        en: 'Delicate',
    },
    restaurant_too_slow: {
        fr: 'Trop lent',
        en: 'Too slow',
    },
    restaurant_poor_packaging: {
        fr: 'Emballage médiocre',
        en: 'Poor packaging',
    },
    restaurant_unsustainable_packaging: {
        fr: 'Conditionnement non durable',
        en: 'Unsustainable packaging',
    },
    restaurant_crispy: {
        fr: 'Croustillant',
        en: 'Crispy',
    },
    restaurant_hot: {
        fr: 'Chaud',
        en: 'Hot',
    },
    restaurant_good_portions: {
        fr: 'Portions généreuses',
        en: 'Good portions',
    },
    restaurant_great_value: {
        fr: 'Consistant',
        en: 'Great value',
    },
    restaurant_honest: {
        fr: 'Honnête',
        en: 'Honest',
    },
    restaurant_the_best: {
        fr: 'Le meilleur',
        en: 'The best',
    },
    restaurant_professional: {
        fr: 'Professionnel',
        en: 'Professional',
    },
    restaurant_correct_order: {
        fr: 'Bonne commande',
        en: 'Correct order',
    },
};

export enum GmbNotificationType {
    GOOGLE_UPDATE = 'GOOGLE_UPDATE',
    NEW_REVIEW = 'NEW_REVIEW',
    UPDATED_REVIEW = 'UPDATED_REVIEW',
    NEW_CUSTOMER_MEDIA = 'NEW_CUSTOMER_MEDIA',
}

export enum GmbOpeningStatus {
    OPEN = 'OPEN',
    CLOSED_TEMPORARILY = 'CLOSED_TEMPORARILY',
}

export const SURFACE_UNSPECIFIED = 'SURFACE_UNSPECIFIED';

export enum CommentDisplayMode {
    POST = 'post',
    LIST = 'list',
}

export enum MentionType {
    POST = 'post',
    COMMENT = 'comment',
}

export enum TemplateTag {
    CLIENT_NAME = '[{client_name}]',
    BUSINESS_NAME = '[{business_name}]',
    MY_FIRSTNAME = '[{my_firstname}]',
    PHONE = '[{phone}]',
    ADDRESS = '[{address}]',
    MENU_LINK = '[{menu_link}]',
    WEBSITE = '[{website}]',
    REGULAR_HOURS = '[{regular_hours}]',
}

export enum DateStringFormat {
    FR = 'fr',
    EN = 'en',
}

export enum JobStatus {
    PENDING = 'pending',
    RUNNING = 'running',
    DONE = 'done',
    FAILED = 'failed',
}

export enum FoundStatusOnPlatform {
    FOUND = 'found',
    NOT_FOUND = 'not_found',
}

export const adminCredentialAuthIds = ['gestionclients@malou.io', '232142364148787', '107323322263317', '122094862952058513'];

export const AI_SOFT_LIMIT_CALL_COUNT = 10000;
export const AI_HARD_LIMIT_CALL_COUNT = 20000;

export enum NfcStar {
    ONE = 1,
    TWO = 2,
    THREE = 3,
    FOUR = 4,
    FIVE = 5,
}

export enum AiTextToOptimizeType {
    REVIEW_ANSWER = 'REVIEW_ANSWER',
    SOCIAL_NETWORK_POST = 'SOCIAL_NETWORK_POST',
    SEO_POST = 'SEO_POST',
}

export enum AiInteractionRelatedEntityCollection {
    POSTS = 'POSTS',
    REVIEWS = 'REVIEWS',
    RESTAURANTS = 'RESTAURANTS',
    REPORTS = 'REPORTS',
    KEYWORDS = 'KEYWORDS',
    HASHTAGS = 'HASHTAGS',
    SIMILAR_RESTAURANTS = 'SIMILAR_RESTAURANTS',
    RESTAURANT_AI_SETTINGS = 'RESTAURANT_AI_SETTINGS',
    DIAGNOSTICS = 'DIAGNOSTICS',
    MEDIA = 'MEDIA',
    CATEGORIES = 'CATEGORIES',
    STORE_LOCATOR_RESTAURANT_PAGE = 'STORE_LOCATOR_RESTAURANT_PAGE',
    STORE_LOCATOR_CENTRALIZATION_PAGE = 'STORE_LOCATOR_CENTRALIZATION_PAGE',
    SEGMENT_ANALYSIS_PARENT_TOPICS = 'SEGMENT_ANALYSIS_PARENT_TOPICS',
    SEGMENT_ANALYSES = 'SEGMENT_ANALYSES',
}

export enum InvalidPlatformReason {
    IG_NOT_FOUND = 'ig_not_found',
    IG_NOT_BUSINESS = 'ig_not_business',
    GMB_DISCONNECTED = 'gmb_disconnected',
    GMB_INVALID_CREDENTIALS = 'gmb_invalid_credentials',
    GMB_DISABLED = 'gmb_disabled',
    GMB_SUSPENDED = 'gmb_suspended',
    GMB_NOT_VERIFIED = 'gmb_not_verified',
    GMB_PENDING_VERIFICATION = 'gmb_pending_verification',
    GMB_OWNERSHIP_CONFLICT = 'gmb_ownership_conflict',
    GMB_WAIT_FOR_VOICE_OF_MERCHANT = 'gmb_wait_for_voice_of_merchant',
    APPLE_DISCONNECTED = 'apple_disconnected',
    APPLE_DELETED = 'apple_deleted',
    APPLE_FAILED = 'apple_failed',
    APPLE_REJECTED = 'apple_rejected',
    APPLE_PUBLISH_PAUSED = 'apple_publish_paused',
    TRIPADVISOR_NOT_MANAGER = 'tripadvisor_not_manager',
    TRIPADVISOR_UNCLAIMED_PAGE = 'tripadvisor_unclaimed_page',
    NEED_REVIEW = 'need_review',
    FB_DISCONNECTED = 'fb_disconnected',
    FB_PASSWORD_CHANGED = 'fb_password_changed',
    FB_LOGIN_AND_FOLLOW_INSTRUCTIONS = 'fb_login_and_follow_instructions',
    FB_INSUFFICIENT_PERMISSIONS_OR_NEED_2FA = 'fb_insufficient_permissions_or_need_2fa',
    FB_INVALID_SOCIAL_ID_OR_MISSING_PERMISSIONS = 'fb_invalid_social_id_or_missing_permissions',
    FB_SESSION_HAS_EXPIRED = 'fb_session_has_expired',
    FB_NOT_CONFIRMED_USER = 'fb_not_confirmed_user',
    FB_USER_NEED_TO_BE_ADMIN_OR_MODERATOR_OR_EDITOR = 'fb_user_need_to_be_admin_or_moderator_or_editor',
    FB_UNABLE_DOWNLOAD_PHOTOS = 'fb_unable_download_photos',
    FB_USER_HAS_NOT_AUTHORIZED_APP = 'fb_user_has_not_authorized_app',
    UNKNOWN = 'unknown',
}

export enum AiInteractionType {
    ANSWER_REVIEW_ADVANCED_SETTINGS = 'answer_review_advanced_settings',
    GENERATE_SOCIAL_NETWORK_POST = 'generate_social_network_post',
    GENERATE_SOCIAL_NETWORK_POST_ADVANCED_SETTINGS = 'generate_social_network_post_advanced_settings',
    GENERATE_SEO_POST = 'generate_seo_post',
    GENERATE_SEO_POST_ADVANCED_SETTINGS = 'generate_seo_post_advanced_settings',
    CHOOSE_POST_HASHTAGS = 'choose_post_hashtags',
    OPTIMIZE_SOCIAL_NETWORK_POST = 'optimize_social_network_post',
    OPTIMIZE_SOCIAL_NETWORK_POST_ADVANCED_SETTINGS = 'optimize_social_network_post_advanced_settings',
    OPTIMIZE_SEO_POST = 'optimize_seo_post',
    OPTIMIZE_SEO_POST_ADVANCED_SETTINGS = 'optimize_seo_post_advanced_settings',
    OPTIMIZE_REVIEW_ANSWER_ADVANCED_SETTINGS = 'optimize_review_answer_advanced_settings',
    BREAKDOWN_AND_CLASSIFY_KEYWORDS = 'breakdown_and_classify_keywords',
    GENERATE_SEMANTIC_ANALYSIS_OVERVIEW = 'generate_semantic_analysis_overview',
    FRENCH_KEYWORDS_GENERATION = 'french_keywords_generation',
    ENGLISH_KEYWORDS_GENERATION = 'english_keywords_generation',
    ITALIAN_KEYWORDS_GENERATION = 'italian_keywords_generation',
    SPANISH_KEYWORDS_GENERATION = 'spanish_keywords_generation',
    KEYWORD_GENERATION = 'keyword_generation',
    KEYWORD_TRANSLATION = 'keyword_translation',
    KEYWORD_ATTRIBUTE_ENHANCEMENT = 'keyword_attribute_enhancement',
    CATEGORIZE_RESTAURANT = 'categorize_restaurant',
    IDENTIFY_SIMILAR_LOCALITIES = 'identify_similar_localities',
    IDENTIFY_SIMILAR_LOCALITIES_FOR_DIAGNOSTIC = 'identify_similar_localities_for_diagnostic',
    REVIEW_TRANSLATION = 'review_translation',
    POST_TRANSLATION = 'post_translation',
    REVIEW_ANSWER_TRANSLATION = 'review_answer_translation',
    INTRODUCTIVE_TRANSLATION = 'introductive_translation',
    SIGNATURE_TRANSLATION = 'signature_translation',
    GENERATE_IMAGE_DESCRIPTION = 'generate_image_description',
    TRANSLATE_TAGS = 'translate_tags',
    GENERATE_SEO_DUPLICATION = 'generate_seo_duplication',
    POST_ADVANCED_SETTINGS_DETECTION = 'post_advanced_settings_detection',
    GENERATE_RS_DUPLICATION = 'generate_rs_duplication',
    REVIEW_RELATED_BRICKS_DETECTION = 'review_related_bricks_detection',
    REVIEW_SEMANTIC_ANALYSIS = 'review_semantic_analysis',
    TOPIC_TRANSLATION = 'topic_translation',
    REVIEW_SEMANTIC_ANALYSIS_AND_TOPIC_LINKING = 'review_semantic_analysis_and_topic_linking',
    REVIEW_SEMANTIC_ANALYSIS_AND_TOPIC_LINKING_V2 = 'review_semantic_analysis_and_topic_linking_v2',
    TOPIC_LINKING = 'topic_linking',
    TOPIC_LINKING_V2 = 'topic_linking_v2',
    TOPIC_CREATION = 'topic_creation',
    REVIEW_ITEM_DETECTION = 'review_item_detection',
    TRANSLATION = 'translation',
    LANGUAGE_DETECTION = 'language_detection',
    ALTERNATIVE_TEXT = 'alternative_text',
    INTELLIGENT_SUBJECTS_DETECTION = 'intelligent_subjects_detection',
    BRAND_KEYWORDS_IDENTIFICATION = 'brand_keywords_identification',
    PREVIOUS_REVIEWS_ANALYSIS_AND_REVIEWER_NAME_VALIDATION = 'previous_reviews_analysis_and_reviewer_name_validation',
    RESPONSE_STYLE_DETECTION = 'response_style_detection',
    REVIEWER_NAME_VALIDATION = 'reviewer_name_validation',
    PREVIOUS_REVIEWS_MATCHING = 'previous_reviews_matching',
    TOPIC_PRUNING = 'topic_pruning',
    TOPIC_REVIEWS_ANALYSIS = 'topic_reviews_analysis',
    CATEGORY_REVIEWS_ANALYSIS = 'category_reviews_analysis',

    // Deprecated : new interactions from sept 2024 should not use/have these types
    TRANSLATE = 'translate',
    ANSWER_REVIEW = 'answer_review',
    OPTIMIZE_REVIEW_ANSWER = 'optimize_review_answer',
}

export enum AiInteractionSubType {
    ANSWER_POSITIVE_REVIEW_WITH_COMMENT_ADVANCED_SETTINGS = 'answer_positive_review_with_comment_advanced_settings',
    ANSWER_POSITIVE_REVIEW_WITHOUT_COMMENT_ADVANCED_SETTINGS = 'answer_positive_review_without_comment_advanced_settings',
    ANSWER_NEGATIVE_REVIEW_WITH_COMMENT_ADVANCED_SETTINGS = 'answer_negative_review_with_comment_advanced_settings',
    ANSWER_NEGATIVE_REVIEW_WITHOUT_COMMENT_ADVANCED_SETTINGS = 'answer_negative_review_without_comment_advanced_settings',
}

export enum PostError {
    POST_ALREADY_PUBLISHED = 'post_already_published',
    POST_STUCK_PROCESSING = 'post_stuck_processing',
    STORY_NOT_PUBLISHED_BECAUSE_PREVIOUS_ONE_WAS_NOT_PUBLISHED = 'story_not_published_because_previous_one_was_not_published',
}

export enum SizeInBytes {
    KiB = 2 ** 10,
    KB = 1_000,
    MiB = 2 ** 20,
    MB = 1_000_000,
    GiB = 2 ** 30,
    GB = 1_000_000_000,
}

export enum InformationUpdateStatus {
    PENDING = 'PENDING',
    VALIDATED = 'VALIDATED',
}

export enum InformationUpdatePlatformStateStatus {
    TO_BE_SENT = 'TO_BE_SENT',
    ERROR = 'ERROR',
    BAD_ACCESS = 'BAD_ACCESS',
    UNCLAIMED_PAGE = 'UNCLAIMED_PAGE',
    INVALID_PAGE = 'INVALID_PAGE',
    MANUAL_UPDATE_ERROR = 'MANUAL_UPDATE_ERROR',
    PENDING = 'PENDING',
    DONE = 'DONE',
}

export enum InformationUpdateAttributeValue {
    YES = 'yes',
    NO = 'no',
}

export enum OpenaiModelVersion {
    DEFAULT_MODEL = 'gpt-3.5-turbo-instruct',
    GPT_3_5_TURBO_1106 = 'gpt-3.5-turbo-1106',
}

export enum RestaurantAttributeValue {
    NOT_CONCERNED = 'notConcerned',
    YES = 'yes',
    NO = 'no',
}

export const USER_AGENTS = [
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/114.0.0.0 Safari/537.36',
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/115.0.0.0 Safari/537.36',
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_5) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/85.0.4183.83 Safari/537.36',
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.87 Safari/537.36',
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0.3 Safari/605.1.15',
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 11_1_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/88.0.4324.192 Safari/537.36',
    'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.127 Safari/537.36',
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/42.0.2311.135 Safari/537.36 Edge/12.246',
    'Mozilla/5.0 (X11; CrOS x86_64 8172.45.0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/51.0.2704.64 Safari/537.36',
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_2) AppleWebKit/601.3.9 (KHTML, like Gecko) Version/9.0.2 Safari/601.3.9',
    'Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/47.0.2526.111 Safari/537.36',
    'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:15.0) Gecko/20100101 Firefox/15.0.1',
];

// ############################################

export enum ChatCompletionRole {
    SYSTEM = 'system',
    USER = 'user',
}

export interface ILatlng {
    lat: number;
    lng: number;
}

export const openTableCookieKey = 'opentable-cookie-otumamiauth';

export enum AppEntity {
    RESTAURANTS = 'restaurants',
    USERS = 'users',
}

export enum PdfFileFormat {
    /** 216 x 279 mm */
    LETTER = 'Letter',
    /** 216 x 356 mm */
    LEGAL = 'Legal',
    /** 279 x 432 mm */
    TABLOID = 'Tabloid',
    /** 210 x 297 mm */
    LEDGER = 'Ledger',
    /** 841 x 1189 mm */
    A0 = 'A0',
    /** 594 x 841 mm */
    A1 = 'A1',
    /** 420 x 594 mm  */
    A2 = 'A2',
    /** 297 x 420 mm */
    A3 = 'A3',
    /** 210 x 297 mm */
    A4 = 'A4',
    /** 148 x 210 mm */
    A5 = 'A5',
    /** 105 x 148 mm */
    A6 = 'A6',
}

export enum Currency {
    EUR = 'EUR', // euro
    USD = 'USD', // dollar
    GBP = 'GBP', // pound
}

export enum WatcherStatus {
    RUNNING = 'running',
    FINISHED = 'finished',
    FAILED = 'failed',
}

export enum PlatformDataFetchedStatus {
    PENDING = 'pending',
    ERROR = 'error',
    SUCCESS = 'success',
    ASYNC = 'async',
}

export enum TooltipPosition {
    TOP = 'top',
    BOTTOM = 'bottom',
    LEFT = 'left',
    RIGHT = 'right',
}
